// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"810fadfe","374":"a5349e9e","453":"db5e21b5","455":"fdc6cbb3","599":"cc3c242e","977":"273dbfb6"}[chunkId] + ".chunk.js";
};